import { z } from 'zod';

export const GetFiatApplicationsResultSchema = z.object({
  user_has_submitted_address_before: z.boolean(),
  application_list: z.record(
    z.object({
      ok: z.boolean(),
      allow_create_application: z.boolean(),
      status: z.string(),
      applications: z.array(
        z.object({
          id: z.string(),
          user_uuid: z.string(),
          status: z.string(),
          service_account_id: z.string(),
          verification_step: z.string(),
          details: z
            .object({
              terms: z.object({
                link: z.string(),
                version: z.string().nullable(),
                created_at: z.string(),
              }),
            })
            .nullable(),
          created_at: z.string(),
          updated_at: z.string(),
          currency: z.string(),
        }),
      ),
    }),
  ),
});

export type GetFiatApplicationsResult = z.infer<
  typeof GetFiatApplicationsResultSchema
>;

export interface GetFiatApplicationsParams {}
